import Contact from "@/components/site/Contact";
import PageHero from "@/components/site/PageHero";

export default function ContactPage() {
  return (
    <>
      <PageHero
        chapter="V"
        eyebrow="Kontakt"
        title="Lass uns gemeinsam"
        italic="schauen."
        intro="Melde dich direkt per E-Mail, Telefon oder vereinbare gleich einen Termin — in einem ersten Gespräch finden wir gemeinsam heraus, ob und wie wir zueinander passen. Unverbindlich und kostenfrei."
        tone="sage"
      />
      <Contact hideIntro />
    </>
  );
}
